import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  settings: Settings = {
    login: 'info random para login',
    data: 'default'
  };

  constructor() {
    this.loadSettings();
  }

  saveSettings() {
    //console.log('Saved Settings');
    localStorage.setItem('settings', JSON.stringify(this.settings));
  }

  loadSettings() {
    if (localStorage.getItem('settings')) {
      this.settings = JSON.parse(localStorage.getItem('settings'));
      //console.log('Loading Settings');
    } else {
      //console.log('No localStorage items');
    }
  }
}

interface Settings {
  login: String;
  data: String;
}
